module.exports = __webpack_public_path__ + "img/Avatar-9.cce1f523.gif";